(function () {
  "use strict";

  a3_cabin_reports.factory("AirlineInfoFactory", AirlineInfoFactory);

  /**
   * Stores crew airline infos/options and backend default selection (FleetId).
   * @ngInject
   */
  function AirlineInfoFactory() {
    var service = {
      // Legacy metadata (company/aoc/address/licenses)
      setCrewAirlineInfos: setCrewAirlineInfos,
      getCrewAirlineInfos: getCrewAirlineInfos,
      clearCrewAirlineInfosFromStorage: clearCrewAirlineInfosFromStorage,

      // Options from active qualifications
      setCrewAirlineOptions: setCrewAirlineOptions,
      getCrewAirlineOptions: getCrewAirlineOptions,
      clearCrewAirlineOptionsFromStorage: clearCrewAirlineOptionsFromStorage,

      // Backend default FleetId
      setDefaultFleetId: setDefaultFleetId,
      getDefaultFleetId: getDefaultFleetId,
      clearDefaultFleetIdFromStorage: clearDefaultFleetIdFromStorage
    };

    function setCrewAirlineInfos(infos) {
      localStorage.setItem("crewAirlineInfos", JSON.stringify(infos || []));
    }

    function getCrewAirlineInfos() {
      return JSON.parse(localStorage.getItem("crewAirlineInfos")) || [];
    }

    function clearCrewAirlineInfosFromStorage() {
      localStorage.removeItem("crewAirlineInfos");
    }

    function setCrewAirlineOptions(options) {
      localStorage.setItem("crewAirlineOptions", JSON.stringify(options || []));
    }

    function getCrewAirlineOptions() {
      return JSON.parse(localStorage.getItem("crewAirlineOptions")) || [];
    }

    function clearCrewAirlineOptionsFromStorage() {
      localStorage.removeItem("crewAirlineOptions");
    }

    function setDefaultFleetId(fleetId) {
      if (fleetId === null || fleetId === undefined || fleetId === "") {
        localStorage.removeItem("defaultFleetId");
        return;
      }
      // Store as string, parse later
      localStorage.setItem("defaultFleetId", String(fleetId));
    }

    function getDefaultFleetId() {
      var v = localStorage.getItem("defaultFleetId");
      if (!v) return null;

      var n = Number(v);
      return isNaN(n) ? null : n;
    }

    function clearDefaultFleetIdFromStorage() {
      localStorage.removeItem("defaultFleetId");
    }

    return service;
  }
})();
